<template>
  <div class="dd-index">
    <!-- 海报 -->
    <div class="dd-banner">
      <div class="dd-banner-bg">
        <div class="dd-banner-bg-pc">
          <img src="../../assets/img/home/dd-banner-04.png" v-show="currentBannerIdx === 1"/>
          <img src="../../assets/img/home/dd-banner-05.png" v-show="currentBannerIdx === 2"/>
          <img src="../../assets/img/home/dd-banner-06.png" v-show="currentBannerIdx === 3"/>
        </div>
        <div class="dd-banner-bg-mobile">
          <div class="dd-banner-bg-mobile-bg" :style="'background: url(' + mobileBgFirst + ') no-repeat center; ' + 'background-size: cover'" v-show="currentBannerIdx === 1"></div>
          <div class="dd-banner-bg-mobile-bg" :style="'background: url(' + mobileBgSecond + ') no-repeat center; ' + 'background-size: cover'" v-show="currentBannerIdx === 2"></div>
          <div class="dd-banner-bg-mobile-bg" :style="'background: url(' + mobileBgThird + ') no-repeat center; ' + 'background-size: cover'" v-show="currentBannerIdx === 3"></div>
          <!--<img src="../../assets/img/home/dd-banner-01.png" v-show="currentBannerIdx === 1"/>
          <img src="../../assets/img/home/dd-banner-02.png" v-show="currentBannerIdx === 2"/>
          <img src="../../assets/img/home/dd-banner-03.png" v-show="currentBannerIdx === 3"/>-->
        </div>
        <div class="dd-banner-content" v-if="currentBannerIdx === 1">
          <div class="dd-banner-title">为设备赋智，为企业赋值</div>
          <div class="dd-banner-sub-title">提供物联网及数据分析端到云的解决方案</div>
        </div>
        <div class="dd-banner-content" v-if="currentBannerIdx === 2">
          <div class="banner-trapezoid-wrap">
            <div class="banner-trapezoid right">
              <div class="banner-trapezoid-label">设备智联运维系统</div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="dd-banner-title">让设备销售与运维更简单、更高效</div>
          <div class="dd-banner-sub-title banner-sub-title-second">降低运维成本，由单纯“卖设备”向“卖服务”转变<br/>由“卖出即结束管理”向“全生命周期管理”转变</div>
        </div>
        <div class="dd-banner-content" v-if="currentBannerIdx === 3">
          <div class="banner-trapezoid-wrap">
            <div class="banner-trapezoid banner-trapezoid-third right">
              <div class="banner-trapezoid-label">工厂数字化监控系统</div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="dd-banner-title">随时随地 管控您的工厂和设备</div>
          <div class="dd-banner-sub-title banner-sub-title-second">助力企业提升质量，降低成本，增产增效，提升管理水平和竞争力</div>
        </div>
        <div class="dd-banner-dot-group-wrap">
          <div class="dd-banner-dot-group">
            <div class="dd-banner-dot left" :class="currentBannerIdx === 1 ? 'banner-dot-active': ''" @click="chooseBannerPage(1)"></div>
            <div class="dd-banner-dot left" :class="currentBannerIdx === 2 ? 'banner-dot-active': ''" @click="chooseBannerPage(2)"></div>
            <div class="dd-banner-dot left" :class="currentBannerIdx === 3 ? 'banner-dot-active': ''" @click="chooseBannerPage(3)"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 平台连接数 -->
    <div class="dd-connect">
      <div class="container dd-connect-container">
        <div class="dd-connect-group">
          <div class="dd-connect-group-item left">
            <img class="d-c-group-item-icon left" src="../../assets/img/home/dd-connect-numb-icon-01.png"/>
            <div class="d-c-group-item-desc left">
              <div class="d-c-group-item-number">248<span>个平台应用</span></div>
              <div class="d-c-group-item-number d-c-group-item-number-mobile">248<span>个</span></div>
              <div class="d-c-group-item-label-mobile">平台应用</div>
            </div>
          </div>
          <div class="dd-connect-group-item d-c-group-item-dark left">
            <img class="d-c-group-item-icon left" src="../../assets/img/home/dd-connect-numb-icon-02.png"/>
            <div class="d-c-group-item-desc left">
              <div class="d-c-group-item-number">768<span>位应用用户</span></div>
              <div class="d-c-group-item-number d-c-group-item-number-mobile">768<span>位</span></div>
              <div class="d-c-group-item-label-mobile">应用用户</div>
            </div>
          </div>
          <div class="dd-connect-group-item left">
            <img class="d-c-group-item-icon left" src="../../assets/img/home/dd-connect-numb-icon-03.png"/>
            <div class="d-c-group-item-desc left">
              <div class="d-c-group-item-number">3674<span>台连接设备</span></div>
              <div class="d-c-group-item-number d-c-group-item-number-mobile">3674<span>台</span></div>
              <div class="d-c-group-item-label-mobile">连接设备</div>
            </div>
          </div>
          <div class="dd-connect-group-item d-c-group-item-dark left">
            <img class="d-c-group-item-icon left" src="../../assets/img/home/dd-connect-numb-icon-04.png"/>
            <div class="d-c-group-item-desc left">
              <div class="d-c-group-item-number">3<span>个今日新增应用</span></div>
              <div class="d-c-group-item-number d-c-group-item-number-mobile">3<span>个</span></div>
              <div class="d-c-group-item-label-mobile">今日新增应用</div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- 实现 -->
    <div class="dd-target">
      <div class="dd-target-container">
        <div class="title dd-target-title">点度为您~实现</div>
        <div class="dd-target-content">
          <div class="dd-target-content-item left">
            <img src="../../assets/img/home/dd-target-icon-01.png"/>
            <div class="target-content-item-label">让设备能说话</div>
            <div class="target-content-item-desc">挖掘海量数据中隐含的巨大宝藏</div>
          </div>
          <div class="dd-target-content-item left">
            <img src="../../assets/img/home/dd-target-icon-02.png"/>
            <div class="target-content-item-label">让设备能互联</div>
            <div class="target-content-item-desc">生产时间更短，效率更高，成本更低</div>
          </div>
          <div class="dd-target-content-item left">
            <img src="../../assets/img/home/dd-target-icon-03.png"/>
            <div class="target-content-item-label">让设备有思想</div>
            <div class="target-content-item-desc">通过数据了解、认识、优化您的生产</div>
          </div>
          <div class="dd-target-content-item left">
            <img src="../../assets/img/home/dd-target-icon-04.png"/>
            <div class="target-content-item-label">让设备都上云</div>
            <div class="target-content-item-desc">随时随地查看设备状态</div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!-- 核心 -->
    <div class="dd-core">
      <div class="dd-core-content">
        <div class="title dd-core-title">核心环节</div>
        <div class="dd-core-nav">
          <div class="dd-core-nav-item-wrap left" v-for="(item, index) in coreList" :key="index">
            <div class="dd-core-nav-item" :class="currentCoreIdx === item.idx ? 'dd-core-nav-item-active': ''" @click="chooseCorePage(item.idx)">{{item.label}}</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-core-content-detail" v-if="currentCoreIdx === 1">
          <div class="core-content-detail-left left">
            <img src="../../assets/img/home/core-bg-01.png"/>
          </div>
          <div class="core-content-detail-right left">
            <div class="c-c-detail-right-label"><span>‘要’</span>数据难？</div>
            <div class="c-c-detail-right-desc">设备多样，数据采集成本大，被设备厂家绑架怎么办？</div>
            <div class="c-c-detail-right-item-logo">
              <img class="right-item-logo left" src="../../assets/img/home/logo.png"/>
              <div class="right-item-logo-text left">点度智能网关</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-01.png"/>
              <div class="c-c-detail-right-item-text left">即插即用，支持三菱、西门子等市面主流工业设备的自动数据解析</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-02.png"/>
              <div class="c-c-detail-right-item-text left">适用于国内90%以上的工厂，助力企业全面融入工业4.0的大潮</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-03.png"/>
              <div class="c-c-detail-right-item-text left">毫秒级实时数据传输、数据传输全程加密，防止数据监听和篡改</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-04.png"/>
              <div class="c-c-detail-right-item-text left">可实现设备PLC程序远程更新</div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-core-content-detail" v-if="currentCoreIdx === 2">
          <div class="core-content-detail-left left">
            <img src="../../assets/img/home/core-bg-02.png"/>
          </div>
          <div class="core-content-detail-right left">
            <div class="c-c-detail-right-label"><span>‘传’</span>数据难？</div>
            <div class="c-c-detail-right-desc">想传数据难？设备想上云，但场地复杂，通讯需求多样化怎么办？</div>
            <div class="c-c-detail-right-item-logo">
              <img class="right-item-logo left" src="../../assets/img/home/logo.png"/>
              <div class="right-item-logo-text left">点度智能通讯</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-05.png"/>
              <div class="c-c-detail-right-item-text left">提供232/485 WiFi WAN NB-IOT 2G/3G/4G等多种通讯方式</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-06.png"/>
              <div class="c-c-detail-right-item-text left">覆盖30多种场景与行业，让设备零门槛连接</div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-core-content-detail" v-if="currentCoreIdx === 3">
          <div class="core-content-detail-left left">
            <img src="../../assets/img/home/core-bg-03.png"/>
          </div>
          <div class="core-content-detail-right left">
            <div class="c-c-detail-right-label"><span>‘存’</span>数据难？</div>
            <div class="c-c-detail-right-desc">想存数据难？想实现设备互联网+却无从下手，需要对接的技术组件多，自建服务器维护花销大怎么办？</div>
            <div class="c-c-detail-right-item-logo">
              <img class="right-item-logo left" src="../../assets/img/home/logo.png"/>
              <div class="right-item-logo-text left">点度智联云</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-07.png"/>
              <div class="c-c-detail-right-item-text left">支持私有云、混合云部署，按需灵活切换</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-08.png"/>
              <div class="c-c-detail-right-item-text left">海量存储，智能连接，设备状态清晰可见</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-09.png"/>
              <div class="c-c-detail-right-item-text left">全球部署，覆盖六大洲，支持国际化需求</div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-core-content-detail" v-if="currentCoreIdx === 4">
          <div class="core-content-detail-left left">
            <img src="../../assets/img/home/core-bg-04.png"/>
          </div>
          <div class="core-content-detail-right left">
            <div class="c-c-detail-right-label"><span>‘挖’</span>数据难？</div>
            <div class="c-c-detail-right-desc">想挖数据难？想精细化控制成本、提高产量，却没有根据，数据分析无从下手，怎么办？</div>
            <div class="c-c-detail-right-item-logo">
              <img class="right-item-logo left" src="../../assets/img/home/logo.png"/>
              <div class="right-item-logo-text left">7大核心算法</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-10.png"/>
              <div class="c-c-detail-right-item-text left">零门槛配置数据可视化模板，随意拖拽，个性化布局全搞定</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-11.png"/>
              <div class="c-c-detail-right-item-text left">保姆式配置多种条件触发规则与预警方式，随心实现功能扩充</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-12.png"/>
              <div class="c-c-detail-right-item-text left">提供1对1数据分析服务，量身定制解决方案，数据赋能竞争力</div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-core-content-detail" v-if="currentCoreIdx === 5">
          <div class="core-content-detail-left left">
            <img src="../../assets/img/home/core-bg-05.png"/>
          </div>
          <div class="core-content-detail-right left">
            <div class="c-c-detail-right-label"><span>‘扩系统’</span>难？</div>
            <div class="c-c-detail-right-desc">想扩展系统难？无专业IT技术，扩展功能成本大，被软件商绑架怎么办？</div>
            <div class="c-c-detail-right-item-logo">
              <img class="right-item-logo left" src="../../assets/img/home/logo.png"/>
              <div class="right-item-logo-text left">赋能企业</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-13.png"/>
              <div class="c-c-detail-right-item-text left">点度智联云支持企业多维度个性化定制</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-14.png"/>
              <div class="c-c-detail-right-item-text left">轻量操作，快速搭建属于自己的物联网数据分析平台</div>
              <div class="clear"></div>
            </div>
            <div class="c-c-detail-right-item">
              <img class="left" src="../../assets/img/home/core-small-icon-15.png"/>
              <div class="c-c-detail-right-item-text left">10天完成项目实施及产品上线。提供一站式后续服务</div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- 方案 -->
    <div class="dd-programme">
      <div class="title">解决方案</div>
      <div class="sub-title">提供工业物联网+整套软硬件解决方案</div>
      <div class="dd-programme-content">
        <div class="trapezoid-left-detail">
          <div class="trapezoid-detail-mask">
            <div class="trapezoid-left-detail-label">
              <div class="t-l-detail-label-text">设备智联运维系统</div>
            </div>
            <div class="trapezoid-left-detail-label-mobile">
              <div class="t-r-detail-label-text">设备智联运维系统</div>
            </div>
            <div class="trapezoid-detail-desc">让设备销售与运维<br/>更简单、更高效</div>
            <div class="trapezoid-detail-sub-desc">降低运维成本<br/>由单纯“卖设备”向“卖服务”转变<br/>由“卖出即结束管理”向“全生命周期管理”转变</div>
            <div class="trapezoid-detail-button t-d-button-left" @click="gotoCasePage()">查看案例</div>
          </div>
        </div>
        <div class="trapezoid-right-detail">
          <div class="trapezoid-detail-mask">
            <div class="trapezoid-right-detail-label">
              <div class="t-r-detail-label-text">工厂数字化监控系统</div>
            </div>
            <div class="trapezoid-detail-desc">随时随地<br/>管控您的工厂和设备</div>
            <div class="trapezoid-detail-sub-desc">助力企业提升质量，降低成本，增产增效<br/>提升管理水平和竞争力</div>
            <div class="trapezoid-detail-button" @click="gotoCasePage()">查看案例</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 价值 -->
    <div class="dd-worth">
      <div class="title">价值效益</div>
      <div class="sub-title">小投入-大回报，效益超乎预期</div>
      <div class="dd-wroth-container">
        <div class="dd-worth-detail-wrap left">
          <div class="worth-detail-title">设备商</div>
          <div class="worth-detail">
            <div class="worth-pie-group">
              <div class="pie-group-item left">
                <img src="../../assets/img/home/dd-worth-pie-01.png"/>
                <div class="pie-group-item-desc">实时监测，快速排故障，<br/> 节省设备故障修复时间</div>
                <div class="pie-group-item-desc-mobile">实时监测，快速排故障，节省设备故障修复时间</div>
              </div>
              <div class="pie-group-item left">
                <img src="../../assets/img/home/dd-worth-pie-02.png"/>
                <div class="pie-group-item-desc">预测性维护，降低<br/>异常停机时间</div>
                <div class="pie-group-item-desc-mobile">预测性维护，降低异常停机时间</div>
              </div>
              <div class="pie-group-item left">
                <img src="../../assets/img/home/dd-worth-pie-03.png"/>
                <div class="pie-group-item-desc">用数据针对性维保换件，<br/>备件费用降低</div>
                <div class="pie-group-item-desc-mobile">用数据针对性维保换件，备件费用降低</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="worth-bar">
              <div class="worth-bar-left-desc">数据智能监测，产品附加值提升</div>
              <div class="worth-bar-left">
                <img class="worth-bar-left-img" src="../../assets/img/home/dd-worth-bar-01.png"/>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-worth-detail-wrap left">
          <div class="worth-detail-title">制造厂</div>
          <div class="worth-detail worth-detail-mobile">
            <div class="worth-pie-group">
              <div class="pie-group-item left">
                <img src="../../assets/img/home/dd-worth-pie-04.png"/>
                <div class="pie-group-item-desc">减少沟通和纸张<br/>的使用</div>
                <div class="pie-group-item-desc-mobile">减少沟通和纸张的使用</div>
              </div>
              <div class="pie-group-item left">
                <img src="../../assets/img/home/dd-worth-pie-05.png"/>
                <div class="pie-group-item-desc">降低数据汇总和<br/>分析时间</div>
                <div class="pie-group-item-desc-mobile">降低数据汇总和分析时间</div>
              </div>
              <div class="pie-group-item left">
                <img src="../../assets/img/home/dd-worth-pie-06.png"/>
                <div class="pie-group-item-desc">降低次品率及次<br/>品成本</div>
                <div class="pie-group-item-desc-mobile">降低数据汇总和分析时间</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="worth-bar-right">
              <div class="worth-bar-right-desc w-b-right-desc-top">工厂全面透明可视，协同效率提升</div>
              <img class="worth-bar-right-img w-b-right-img-top" src="../../assets/img/home/dd-worth-bar-02.png"/>
            </div>
            <div class="worth-bar-right">
              <div class="worth-bar-right-desc w-b-right-desc-middle">人员生产率提升</div>
              <img class="worth-bar-right-img" src="../../assets/img/home/dd-worth-bar-03.png"/>
            </div>
            <div class="worth-bar-right">
              <div class="worth-bar-right-desc">设备OEE提升</div>
              <img class="worth-bar-right-img" src="../../assets/img/home/dd-worth-bar-04.png"/>
            </div>
            <div class="worth-detail-tip">举例：一台月产值5万元的设备，OEE提升1%，则年产值增加50000*1%*12=6000元。</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 应用 -->
    <div class="dd-application">
      <div class="dd-application-container">
        <div class="title dd-application-title">验证式应用</div>
        <div class="sub-title">投入小于2万，一月内落地，每季度评估</div>
        <div class="dd-app-guide">
          <div class="app-guide-item left">
            <div class="app-guide-item-desc">
              <p class="a-g-i-desc-p desc-p-one">选择5-10台设备</p>
            </div>
            <div class="app-guide-item-line"></div>
            <div class="app-guide-item-circle g-i-circle-brown"></div>
          </div>
          <div class="app-guide-item left">
            <div class="app-guide-item-desc">
              <p class="a-g-i-desc-p desc-p-two">投入与验证周期<br/>（1-3个月）</p>
            </div>
            <div class="app-guide-item-line"></div>
            <div class="app-guide-item-circle g-i-circle-purple"></div>
          </div>
          <div class="app-guide-item left">
            <div class="app-guide-item-desc">
              <p class="a-g-i-desc-p desc-p-three">评估报告<br/>每季度一份</p>
            </div>
            <div class="app-guide-item-line"></div>
            <div class="app-guide-item-circle g-i-circle-blue"></div>
          </div>
          <div class="app-guide-item left">
            <div class="app-guide-item-desc">
              <p class="a-g-i-desc-p desc-p-four">持续提升<br/>路径决策</p>
            </div>
            <div class="app-guide-item-line"></div>
            <div class="app-guide-item-circle g-i-circle-orange"></div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="dd-app-content">
          <div class="app-content-item-wrap left">
            <div class="app-content-item-one">
              <div class="app-content-item-desc a-c-i-desc-one">
                <p class="a-c-i-desc-one-p">选择5-10台设备<br/>1-3个月时间验证</p>
              </div>
              <i class="el-icon-d-arrow-right arrow-right-icon-one"></i>
            </div>
          </div>
          <div class="app-content-item-wrap left">
            <div class="app-content-item-two app-content-item-border">
              <div class="app-content-item-desc a-c-i-desc-two a-c-i-desc-two-top">一次性硬件投入</div>
              <div class="app-content-item-desc a-c-i-desc-two a-c-i-desc-two-bottom">12个月服务租金</div>
              <div class="a-c-i-desc-tip">启动资金1-2万元；见效果：&lt;1个月内</div>
              <i class="el-icon-d-arrow-right arrow-right-icon-two"></i>
            </div>
          </div>
          <div class="app-content-item-wrap left">
            <div class="app-content-item-three app-content-item-border">
              <div class="app-content-item-desc a-c-i-desc-three a-c-i-desc-three-top">OEE提升评估报告</div>
              <div class="app-content-item-desc a-c-i-desc-three">投资回收测算报告</div>
              <div class="app-content-item-desc a-c-i-desc-three">用户诉求报告</div>
              <i class="el-icon-d-arrow-right arrow-right-icon-three"></i>
            </div>
          </div>
          <div class="app-content-item-wrap left">
            <div class="app-content-item-four app-content-item-border">
              <div class="app-content-item-desc a-c-i-desc-four a-c-i-desc-four-top">扩大应用范围</div>
              <div class="app-content-item-desc a-c-i-desc-four">智能制造升级</div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <!-- 移动端样式 -->
        <div class="dd-app-guide-mobile">
          <el-timeline>
            <el-timeline-item
              placement="top"
              color="#958E71"
              size="large">
              <div class="dd-app-guide-label">选择5-10台设备</div>
              <el-card>
                <div class="app-content-item-wrap left">
                  <div class="app-content-item-one">
                    <div class="app-content-item-desc a-c-i-desc-one">
                      <p class="a-c-i-desc-one-p">选择5-10台设备<br/>1-3个月时间验证</p>
                    </div>
                  </div>
                  <div class="dd-app-guide-arrow">
                    <i class="el-icon-d-arrow-right arrow-right-icon-one"></i>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              placement="top"
              color="#C752FB"
              size="large">
              <div class="dd-app-guide-label">投入与验证周期（1-3个月）</div>
              <el-card>
                <div class="app-content-item-wrap left">
                  <div class="app-content-item-two app-content-item-border">
                    <div class="app-content-item-desc a-c-i-desc-two a-c-i-desc-two-top">一次性硬件投入</div>
                    <div class="app-content-item-desc a-c-i-desc-two a-c-i-desc-two-bottom">12个月服务租金</div>
                    <div class="a-c-i-desc-tip">启动资金1-2万元；见效果：&lt;1个月内</div>
                  </div>
                  <div class="dd-app-guide-arrow">
                    <i class="el-icon-d-arrow-right arrow-right-icon-two"></i>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              placement="top"
              color="#00B1FF"
              size="large">
              <div class="dd-app-guide-label">评估报告每季度一份</div>
              <el-card>
                <div class="app-content-item-wrap left">
                  <div class="app-content-item-three app-content-item-border">
                    <div class="app-content-item-desc a-c-i-desc-three a-c-i-desc-three-top">OEE提升评估报告</div>
                    <div class="app-content-item-desc a-c-i-desc-three">投资回收测算报告</div>
                    <div class="app-content-item-desc a-c-i-desc-three">用户诉求报告</div>
                  </div>
                  <div class="dd-app-guide-arrow">
                    <i class="el-icon-d-arrow-right arrow-right-icon-three"></i>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item
              placement="top"
              color="#FF7600"
              size="large">
              <div class="dd-app-guide-label">持续提升路径决策</div>
              <el-card>
                <div class="app-content-item-wrap left">
                  <div class="app-content-item-four app-content-item-border">
                    <div class="app-content-item-desc a-c-i-desc-four a-c-i-desc-four-top">扩大应用范围</div>
                    <div class="app-content-item-desc a-c-i-desc-four">智能制造升级</div>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 合作伙伴 -->
    <div class="dd-partner">
      <div class="dd-cp-container">
        <div class="title">合作伙伴</div>
        <div class="sub-title">感谢诸位合作伙伴的热情支持</div>
        <div class="dd-cp-content">
          <div class="dd-cp-group">
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-01.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-02.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-03.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-04.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-05.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-06.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-07.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-08.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-09.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-partner-10.jpg"/>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- 客户 -->
    <div class="dd-customer">
      <div class="dd-cp-container">
        <div class="title">服务客户</div>
        <div class="sub-title">感谢客户们的信任和支持，感恩一路有您</div>
        <div class="dd-cp-content">
          <div class="dd-cp-group">
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-01.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-02.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-03.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-04.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-05.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-06.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-07.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-08.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-09.jpg"/>
            </div>
            <div class="dd-cp-group-item left">
              <img src="../../assets/img/home/dd-customer-10.jpg"/>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      currentBannerIdx: 1,
      bannerInterval: null,
      coreList: [
        {idx: 1, label: '数据采集'},
        {idx: 2, label: '通讯多样'},
        {idx: 3, label: '设备上云'},
        {idx: 4, label: '数据挖掘'},
        {idx: 5, label: '赋能企业'}
      ],
      currentCoreIdx: 1,
      mobileBgFirst: require('../../assets/img/home/dd-banner-01.png'),
      mobileBgSecond: require('../../assets/img/home/dd-banner-02.png'),
      mobileBgThird: require('../../assets/img/home/dd-banner-03.png')
    }
  },
  created () {
    this.bannerInterval = setInterval(() => {
      let idx = this.currentBannerIdx
      if (idx < 3) {
        this.currentBannerIdx = idx + 1
      } else {
        this.currentBannerIdx = 1
      }
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.bannerInterval)
    this.currentBannerIdx = 1
  },
  methods: {
    chooseBannerPage (idx) {
      this.currentBannerIdx = idx
    },
    chooseCorePage (idx) {
      this.currentCoreIdx = idx
    },
    gotoCasePage () {
      this.$router.push({path: '/case'})
    }
  }
}
</script>

<style scoped>
  .el-card {
    background-color: unset;
    border: unset;
  }
  .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    box-shadow: unset;
  }
  .title {
    font-size: 36px;
    text-align: center;
    color: #062951;
    padding-top: 30px;
  }
  .sub-title {
    font-size: 16px;
    text-align: center;
    color: #C752FB;
  }
  .dd-banner {
    width: 100%;
  }
  .dd-banner-bg {
    width: 100%;
    position: relative;
  }
  .dd-banner-bg-mobile {
    display: none;
  }
  .dd-banner-bg-mobile-bg {
    width: 100%;
    height: 170px;
  }
  .dd-banner-bg img{
    width: 100%;
    height: auto;
  }
  .dd-banner-content {
    width: 100%;
    position: absolute;
    top: 33%;
    text-align: center;
  }
  .dd-banner-title {
    font-size: 63px;
    color: #ffffff;
  }
  .dd-banner-sub-title {
    font-size: 24px;
    color: #FFCE00;
  }
  .banner-trapezoid {
    width: 300px;
    height: 0;
    border-bottom: 36px solid #FFA700;
    border-left: 26px solid transparent;
    margin-right: 25%;
  }
  .banner-trapezoid-label {
    color: #fff;
    font-size: 22px;
    line-height: 36px;
    text-align: right;
    margin-right: 12px;
  }
  .banner-trapezoid-third {
    border-bottom: 36px solid #00A8FF;
    margin-right: 28%;
  }
  .banner-sub-title-second {
    color: #ffffff;
  }
  .dd-banner-dot-group-wrap {
    width: 100%;
    position: absolute;
    bottom: 20px;
  }
  .dd-banner-dot-group {
    width: 72px;
    margin: auto;
  }
  .dd-banner-dot {
    width: 20px;
    height: 20px;
    margin: 0 2px;
    border: 1px solid lightgray;
    border-radius: 10px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .banner-dot-active {
    background-color: #C752FB;
  }
  .dd-banner-dot:hover {
    background-color: #ffffff;
  }
  .dd-connect {
    width: 100%;
    background-color: #f0f0f0;;
    color: #062951;;
  }
  .dd-connect-group-item {
    width: 25%;
    height: 40px;
    padding: 0 30px;
    box-sizing: border-box;
    background-color: #e2e2e2;
  }
  .d-c-group-item-dark {
    background-color: #d6d5d5;
  }
  .d-c-group-item-icon {
    width: 25px;
    margin-top: 8px;
  }
  .d-c-group-item-desc {
    width: calc(100% - 35px);
    margin-left: 10px;
  }
  .d-c-group-item-number {
    font-size: 22px;
    margin-top: 8px;
  }
  .d-c-group-item-number span {
    font-size: 14px;
    margin-left: 6px;
  }
  .d-c-group-item-number-mobile {
    font-size: 18px;
    display: none;
  }
  .d-c-group-item-number-mobile span {
    font-size: 12px;
  }
  .d-c-group-item-label-mobile {
    display: none;
    font-size: 12px;
    margin-top: -4px;
  }
  .dd-target {
    padding-bottom: 70px;
    background-color: #ffffff;
  }
  .dd-target-container {
    width: 100%;
    max-width: 1440px;
    margin: auto;
  }
  .dd-target-title {
    padding-top: 20px;
  }
  .dd-target-content {
    margin-top: 20px;
  }
  .dd-target-content-item {
    width: 25%;
    padding: 0 15px;
    text-align: center;
    box-sizing: border-box;
  }
  .dd-target-content-item:hover {
    transform: scale(1.2);
  }
  .dd-target-content-item img {
    max-width: 150px;
    margin: auto;
  }
  .target-content-item-label {
    font-size: 24px;
    color: #062951;
    margin-top: 10px;
  }
  .target-content-item-desc {
    font-size: 16px;
    color: rgba(6, 41, 81, .5);
  }
  .dd-core {
    width: 100%;
    background: #ffffff url("../../assets/img/home/dd-code-bg.png") no-repeat center;
    padding-bottom: 65px;
    background-size: cover;
  }
  .dd-core-content {
    width: 100%;
    max-width: 1080px;
    margin: auto;
    padding: 30px 15px 0 15px;
    box-sizing: border-box;
  }
  .dd-core-title {
    padding-top: 0;
  }
  .dd-core-nav {
    margin-top: 50px;
  }
  .dd-core-nav-item-wrap {
    width: 20%;
    cursor: pointer;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .dd-core-nav-item {
    width: 100%;
    height: 36px;
    text-align: center;
    line-height: 36px;
    font-size: 18px;
    color: #062951;
    border-radius: 18px;
    background-color: #f4f4f4;
    margin: auto;
  }
  .dd-core-nav-item-active {
    color: #ffffff;
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .dd-core-nav-item:hover {
    color: #ffffff;
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .dd-core-content-detail {
    margin-top: 45px;
  }
  .core-content-detail-left {
    width: 470px;
    height: 300px;
    border-radius: 16px;
  }
  .core-content-detail-left img {
    width: 100%;
    height: auto;
  }
  .core-content-detail-right {
    width: calc(100% - 515px);
    margin-left: 45px;
    color: #062951;
  }
  .c-c-detail-right-label {
    font-size: 22px;
  }
  .c-c-detail-right-label span {
    color: #C752FB;
  }
  .c-c-detail-right-desc {
    font-size: 16px;
    margin-bottom: 30px;
  }
  .c-c-detail-right-item-logo {
    width: 100%;
    margin-bottom: 30px;
  }
  .c-c-detail-right-item {
    width: 100%;
    margin-bottom: 18px;
    padding-left: 32px;
    box-sizing: border-box;
  }
  .c-c-detail-right-item img {
    width: 22px;
    height: 22px;
    margin-left: -32px;
  }
  .c-c-detail-right-item-text {
    font-size: 16px;
  }
  .right-item-logo {
    width: 24px;
  }
  .right-item-logo-text {
    font-size: 22px;
    margin: -4px 0 0 10px;
  }
  .dd-programme {
    background-color: #fff;
  }
  .dd-programme-content {
    position: relative;
    height: 560px;
    background: url("../../assets/img/home/dd-programme-bg.png") no-repeat center;
    margin-top: 28px;
  }
  .trapezoid-left-detail {
    position: absolute;
    top: 47px;
    right: 50%;
    text-align: right;
  }
  .trapezoid-right-detail {
    position: absolute;
    bottom: 43px;
    left: 50%;
    text-align: left;
  }
  .trapezoid-left-detail-label {
    width: 272px;
    height: 0;
    border-bottom: 36px solid #ffa700;
    border-left: 30px solid transparent;
    margin-left: 42px;
  }
  .trapezoid-left-detail-label-mobile {
    display: none;
    width: 272px;
    height: 0;
    border-top: 36px solid #ffa700;
    border-right: 30px solid transparent;
    border-radius: 18px;
  }
  .trapezoid-right-detail-label {
    width: 272px;
    height: 0;
    border-top: 36px solid #529afb;
    border-right: 30px solid transparent;
  }
  .t-l-detail-label-text {
    font-size: 22px;
    color: #ffffff;
    line-height: 36px;
    margin-right: 12px;
  }
  .t-r-detail-label-text {
    font-size: 22px;
    color: #ffffff;
    line-height: 36px;
    margin-top: -36px;
    margin-left: 12px;
  }
  .trapezoid-detail-desc {
    font-size: 43px;
    color: #ffffff;
    line-height: 50px;
  }
  .trapezoid-detail-sub-desc {
    font-size: 16px;
    color: #ffffff;
  }
  .trapezoid-detail-button {
    width: 108px;
    height: 32px;
    font-size: 16px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    border-radius: 16px;
    cursor: pointer;
    background: linear-gradient(to right,#c352fa,#4c46bd);
    margin-top: 10px;
  }
  .trapezoid-detail-button:hover {
    transform: scale(1.2);
  }
  .t-d-button-left {
    margin-left: 180px;
  }
  .dd-wroth-container {
    width: 100%;
    max-width: 1290px;
    margin: auto;
    margin-top: 33px;
  }
  .worth-detail-title {
    font-size: 22px;
    color: #062951;
    text-align: center;
  }
  .dd-worth-detail-wrap {
    width: 50%;
    padding: 0 30px;
    box-sizing: border-box;
  }
  .worth-detail {
    width: 100%;
    height: 370px;
    border-radius: 16px;
    border: 1px solid lightgray;
    box-shadow: 5px 5px 5px lightgray;
    margin-top: 8px;
    background-color: #ffffff;
  }
  .worth-pie-group {
    margin-top: 26px;
  }
  .pie-group-item {
    width: 33.3%;
    padding: 0 12px;
    box-sizing: border-box;
  }
  .pie-group-item:hover {
    transform: scale(1.2);
  }
  .pie-group-item img {
    margin: auto;
  }
  .pie-group-item-desc {
    font-size: 14px;
    color: #062951;
    text-align: center;
  }
  .pie-group-item-desc-mobile {
    display: none;
    font-size: 14px;
    color: #062951;
    text-align: center;
  }
  .worth-bar {
    margin-top: 50px;
  }
  .worth-bar-left-desc {
    font-size: 14px;
    color: #062951;
    text-align: center;
  }
  .worth-bar-left {
    padding: 0 60px;
    box-sizing: border-box;
  }
  .worth-bar-left-img {
    width: 100%;
  }
  .worth-bar-right {
    padding: 0 25px;
    box-sizing: border-box;
  }
  .worth-bar-right-desc {
    color: #062951;
    text-align: right;
    margin-right: 192px;
  }
  .w-b-right-desc-top {
    margin-top: 10px;
  }
  .w-b-right-img-top {
    margin-top: -25px;
  }
  .w-b-right-desc-middle {
    margin-top: 5px;
  }
  .worth-bar-right-img {
    width: 100%;
  }
  .worth-detail-tip {
    font-size: 12px;
    color: #989898;
    margin-left: 28px;
  }
  .dd-application {
    background-color: #062951;
    margin-top: 54px;
  }
  .dd-application-container {
    width: 100%;
    max-width: 1068px;
    margin: auto;
  }
  .dd-application-title {
    font-size: 36px;
    color: #ffffff;
    padding-top: 30px;
    margin-top: 0;
  }
  .dd-app-guide {
    margin-top: 54px;
    margin-bottom: 10px;
  }
  .dd-app-guide-mobile {
    display: none;
    width: 100%;
    padding: 30px 15%;
    box-sizing: border-box;
  }
  .app-guide-item {
    width: 25%;
  }
  .app-guide-item-desc {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
    min-height: 38px;
    position: relative;
  }
  .a-g-i-desc-p {
    width: 100%;
    position: absolute;
    bottom: 0;
    margin: 0 0 18px 0;
  }
  .desc-p-one {
    left: -38px;
  }
  .desc-p-two {
    left: -8px;
  }
  .desc-p-three {
    left: -10px;
  }
  .desc-p-four {

  }
  .app-guide-item-line {
    width: 100%;
    height: 1px;
    background-color: #707070;
  }
  .app-guide-item-circle {
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: lightblue;
    margin: auto;
    margin-top: -10px;
  }
  .g-i-circle-brown {
    background-color: #958E71;
    margin-left: 83px;
  }
  .g-i-circle-purple {
    background-color: #C752FB;
    margin-left: 120px;
  }
  .g-i-circle-blue {
    background-color: #00B1FF;
    margin-left: 118px;
  }
  .g-i-circle-orange {
    background-color: #FF7600;
  }
  .app-content-item-wrap {
    width: 25%;
    height: 300px;
    box-sizing: border-box;
    position: relative;
  }
  .app-content-item-desc {
    width: 182px;
    height: 50px;
    font-size: 18px;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
    border-radius: 10px;
    background-color: salmon;
  }
  .app-content-item-desc:hover {
    transform: scale(1.2);
  }
  .a-c-i-desc-one {
    height: 83px;
    margin-top: 71px;
    background-color: #958E71;
    line-height: unset;
  }
  .a-c-i-desc-one-p {
    margin: 0;
    padding-top: 18px;
  }
  .a-c-i-desc-two {
    margin: 13px auto 0;
    background-color: #C752FB;
  }
  .a-c-i-desc-two-top {
    margin-top: 20px;
  }
  .a-c-i-desc-two-bottom {
    margin-top: 13px;
  }
  .a-c-i-desc-tip {
    font-size: 12px;
    color: #C4C4C4;
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 5px;
  }
  .arrow-right-icon-one {
    position: absolute;
    top: 95px;
    left: 216px;
    font-size: 27px;
    color: #958E71;
  }
  .arrow-right-icon-two {
    position: absolute;
    top: 95px;
    left: 245px;
    font-size: 27px;
    color: #C752FB;
  }
  .arrow-right-icon-three {
    position: absolute;
    top: 95px;
    left: 250px;
    font-size: 27px;
    color: #00B1FF;
  }
  .app-content-item-two {
    width: 240px;
    height: 170px;
    margin-top: 30px;
  }
  .app-content-item-three {
    width: 240px;
    height: 220px;
    margin-left: 5px;
  }
  .app-content-item-four {
    width: 240px;
    height: 155px;
    margin-left: 10px;
    margin-top: 28px;
  }
  .a-c-i-desc-three {
    margin: 13px auto 0;
    background-color: #00B1FF;
  }
  .a-c-i-desc-three-top {
    margin-top: 20px;
  }
  .a-c-i-desc-four {
    margin: 13px auto 0;
    background-color: #FF7600;
  }
  .a-c-i-desc-four-top {
    margin-top: 20px;
  }
  .app-content-item-border {
    border-radius: 10px;
    padding: 1px;
    border: 1px dashed transparent;
    background: linear-gradient(#062951,#062951) padding-box, repeating-linear-gradient(-45deg,#062951 0, #062951 0.25em,#707070 0,#707070 0.75em);
  }
  .dd-cp-container {
    width: 100%;
    max-width: 1230px;
    margin: auto;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .dd-partner {
    background-color: #ffffff;
    padding-bottom: 80px;
  }
  .dd-customer {
    padding-bottom: 75px;
    background-color: #ffffff;
  }
  .dd-cp-content {
    margin-top: 35px;
  }
  .dd-cp-group-item {
    width: 20%;
    padding: 3px;
    box-sizing: border-box;
    overflow: hidden;
  }
  .dd-cp-group-item img{
    width: 100%;
    height: auto;
  }
  .dd-cp-group-item img:hover {
    transform: scale(1.2);
  }
  @media all and (max-width: 1430px) {
    .dd-connect-container {
      padding: 0;
    }
    .dd-target-content-item:hover {
      transform: scale(1);
    }
    .trapezoid-detail-button:hover {
      transform: scale(1);
    }
    .pie-group-item:hover {
      transform: scale(1);
    }
    .app-content-item-desc:hover {
      transform: scale(1);
    }
    .dd-cp-group-item img:hover {
      transform: scale(1);
    }
  }
  @media all and (max-width: 1200px) {
    .dd-banner-title {
      font-size: 32px;
    }
    .dd-banner-sub-title {
      font-size: 16px;
    }
    .banner-trapezoid {
      width: 180px;
      border-bottom: 30px solid #FFA700;
    }
    .banner-trapezoid-label {
      font-size: 16px;
      line-height: 30px;
    }
    .banner-trapezoid-third {
      border-bottom: 30px solid #00A8FF;
    }
    .dd-connect-group-item {
      padding: 0 10px;
    }
    .dd-target-content-item img {
      max-width: 130px;
      width: 100%;
    }
    .target-content-item-desc {
      font-size: 14px;
    }
    .core-content-detail-right {
      width: calc(100% - 495px);
      margin-left: 25px;
    }
    .c-c-detail-right-item-logo {
      margin-bottom: 25px;
    }
    .c-c-detail-right-item {
      margin-bottom: 15px;
    }
    .dd-worth-detail-wrap {
      width: 50%;
      padding: 0 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .worth-bar-right-desc {
      margin-right: 153px;
    }
    .w-b-right-img-top {
      margin-top: -16px;
    }
    .pie-group-item {
      padding: 0;
    }
    .dd-application-container {
      padding: 0 15px;
      box-sizing: border-box;
    }
    .desc-p-two {
      left: -18px;
    }
    .g-i-circle-purple {
      margin-left: 102px;
    }
    .desc-p-three {
      left: -18px;
    }
    .g-i-circle-blue {
      margin-left: 103px;
    }
    .desc-p-four {
      margin-left: -16px;
    }
    .g-i-circle-orange {
      margin-left: 109px;
    }
    .app-content-item-two {
      width: 210px;
    }
    .app-content-item-three {
      width: 210px;
    }
    .app-content-item-four {
      width: 210px;
    }
    .arrow-right-icon-one {
      left: 200px;
    }
    .arrow-right-icon-two {
      left: 218px;
    }
    .arrow-right-icon-three {
      left: 223px;
    }
  }
  @media all and (max-width: 990px) {
    .dd-target-content {
      padding: 0 6%;
    }
    .dd-target-content-item {
      width: 50%;
      margin-bottom: 30px;
    }
    .dd-core {
      background: unset;
      background-color: #ffffff;
    }
    .dd-core-nav-item-wrap {
      width: 33%;
      padding: 0 25px 0 0;
      margin-bottom: 20px;
    }
    .dd-core-content-detail {
      margin-top: 0;
    }
    .core-content-detail-left {
      width: 100%;
      height: unset;
    }
    .core-content-detail-left img {
      max-width: 500px;
      margin: auto;
    }
    .core-content-detail-right {
      width: 100%;
      margin-left: 0;
      margin-top: 30px;
    }
    .dd-programme {
      padding-bottom: 65px;
    }
    .dd-programme-content {
      height: unset;
      background: unset;
      margin-top: 28px;
      background-color: #ffffff;
      box-sizing: border-box;
    }
    .trapezoid-left-detail-label {
      display: none;
    }
    .trapezoid-left-detail-label-mobile {
      display: block;
      border-right: 0 solid transparent;
      margin: 20px auto;
    }
    .t-r-detail-label-text {
      margin-left: 0;
    }
    .trapezoid-right-detail-label {
      border-right: 0 solid transparent;
      margin: 20px auto;
      border-radius: 18px;
    }
    .trapezoid-detail-desc {
      /*color: #062951;*/
      margin-bottom: 20px;
    }
    .trapezoid-detail-sub-desc {
     /* color: #062951;*/
    }
    .trapezoid-detail-mask {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      padding: 15px;
      box-sizing: border-box;
    }
    .trapezoid-left-detail {
      position: unset;
      top: unset;
      right: unset;
      text-align: center;
      width: 100%;
      height: 360px;
      box-sizing: border-box;
      background: url("../../assets/img/home/dd-solution-bg-01.png") no-repeat center;
      background-size: cover;
    }
    .t-d-button-left {
      margin: 20px auto;
    }
    .trapezoid-right-detail {
      position: unset;
      bottom: unset;
      left: unset;
      text-align: center;
      width: 100%;
      height: 360px;
      box-sizing: border-box;
      background: url("../../assets/img/home/dd-solution-bg-02.png") no-repeat center;
      background-size: cover;
      margin-top: 15px;
    }
    .trapezoid-detail-button {
      margin: 20px auto;
    }
    .dd-worth {
      background-color: #ffffff;
    }
    .dd-wroth-container {
      padding-bottom: 50px;
    }
    .dd-worth-detail-wrap {
      width: 100%;
      margin-bottom: 40px;
    }
    .worth-detail {
      margin: 8px auto 0 auto;
    }
    .worth-detail-mobile {
      height: unset;
      padding-bottom: 40px;
    }
    .dd-cp-group-item {
      width: 25%;
    }
    .dd-application {
      margin-top: 0;
    }
    .dd-app-guide {
      display: none;
    }
    .dd-app-content {
      display: none;
    }
    .dd-app-guide-mobile {
      display: block;
    }
    .app-content-item-wrap {
      width: 100%;
      height: unset;
    }
    .a-c-i-desc-one {
      margin: 0 auto;
      width: 250px;
    }
    .app-content-item-two {
      margin: 0 auto;
      width: 300px;
    }
    .app-content-item-three {
      margin: 0 auto;
      width: 300px;
    }
    .app-content-item-four {
      margin: 0 auto;
      width: 300px;
    }
    .arrow-right-icon-one {
      position: unset;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      -o-transform: rotate(90deg);
    }
    .arrow-right-icon-two {
      position: unset;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      -o-transform: rotate(90deg);
    }
    .arrow-right-icon-three {
      position: unset;
      transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -webkit-transform: rotate(90deg);
      -o-transform: rotate(90deg);
    }
    .dd-app-guide-label {
      font-size: 18px;
      color: #ffffff;
      margin-top: -14px;
    }
    .dd-app-guide-arrow {
      width: 27px;
      margin: 10px auto 0 auto;
    }
  }
  @media all and (max-width: 730px) {
    .d-c-group-item-number {
      display: none;
    }
    .d-c-group-item-number-mobile {
      display: block;
    }
    .dd-connect-group-item {
      height: 65px;
      padding: 0 7px;
    }
    .d-c-group-item-icon {
      width: 20px;
      float: unset;
      margin: 5px auto 0 auto;
    }
    .d-c-group-item-desc {
      width: 100%;
      margin: -6px 0 0 0;
      text-align: center;
    }
    .d-c-group-item-label-mobile {
      display: block;
    }
  }
  @media all and (max-width: 650px) {
    .title {
      font-size: 28px;
      padding-top: 30px;
    }
    .dd-banner-bg-pc {
      display: none;
    }
    .dd-banner-bg-mobile {
      display: block;
    }
    .dd-banner-content {
      display: none;
    }
    .dd-banner-dot {
      width: 14px;
      height: 14px;
      border-radius: 7px;
    }
    .dd-target {
      padding-bottom: 0;
    }
    .dd-target-title {
      padding-top: 15px;
    }
    .dd-target-content {
      margin-top: 10px;
    }
    .dd-target-content-item {
      margin-bottom: 20px;
    }
    .dd-target-content-item img {
      max-width: 80px;
    }
    .target-content-item-label {
      font-size: 18px;
    }
    .target-content-item-desc {
      font-size: 14px;
    }
    .dd-core-content {
      padding-top: 0;
    }
    .dd-core-nav {
      margin-top: 20px;
    }
    .dd-core-nav-item {
      font-size: 14px;
    }
    .dd-core-nav-item-wrap {
      padding-right: 10px;
    }
    .core-content-detail-right {
      margin-top: 20px;
    }
    .c-c-detail-right-label {
      font-size: 18px;
    }
    .c-c-detail-right-desc {
      font-size: 14px;
    }
    .right-item-logo-text {
      font-size: 18px;
      margin-top: 0;
    }
    .c-c-detail-right-item-text {
      font-size: 14px;
      margin-top: -4px;
    }
    .c-c-detail-right-item-logo {
      margin-bottom: 20px;
    }
    .dd-core {
      padding-bottom: 0;
    }
    .dd-wroth-container {
      padding-bottom: 30px;
    }
    .dd-programme {
      padding-bottom: 0;
    }
    .dd-programme-content {
      margin-top: 20px;
    }
    .trapezoid-detail-mask {
      padding: 15px 0;
    }
    .trapezoid-left-detail {
      margin-bottom: 20px;
      height: 330px;
    }
    .trapezoid-right-detail {
      margin-top: 0;
      height: 330px;
    }
    .trapezoid-detail-desc {
      font-size: 28px;
      line-height: unset;
    }
    .trapezoid-detail-sub-desc {
      font-size: 14px;
    }
    .worth-detail {
      height: unset;
      padding-bottom: 40px;
    }
    .pie-group-item {
      width: 33.3%;
      margin-bottom: 20px;
      padding: 0 3px;
    }
    .pie-group-item img {
      max-width: 80px;
    }
    .pie-group-item-desc {
      display: none;
    }
    .pie-group-item-desc-mobile {
      display: block;
    }
    .worth-bar-right-desc {
      margin-right: 0;
      text-align: center;
    }
    .w-b-right-desc-top {
      margin-bottom: 5px;
      margin-right: 20px;
    }
    .worth-bar-left {
      padding: 0 25px;
    }
    .worth-detail-tip {
      margin: 0 25px;
    }
    .dd-application {
      margin-top: 0;
    }
    .dd-app-guide-mobile {
      padding: 30px 15px;
    }
    .a-c-i-desc-one {
      width: 200px;
    }
    .app-content-item-two {
      width: 246px;
    }
    .app-content-item-three {
      width: 246px;
    }
    .app-content-item-four {
      width: 246px;
    }
    .dd-partner {
      padding-bottom: 0;
    }
    .dd-customer {
      padding-bottom: 35px;
    }
    .dd-cp-group-item {
      width: 50%;
    }
  }
  @media all and (max-width: 350px) {
    .app-content-item-two {
      width: 226px;
      margin-left: -20px;
    }
    .app-content-item-three {
      width: 226px;
      margin-left: -20px;
    }
    .app-content-item-four {
      width: 226px;
      margin-left: -20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue